export enum historyCategoryEnum {
  last7days = 'Last 7 days',
  last30days = 'Last 30 days',
  older = 'Older than 30 days',
}
